import styled from 'styled-components';
import React from 'react';
import {colorTheme} from '../../ui-toolkit/mixin/colorTheme';
import {HeaderTitle} from '../custom-features/app-element/Title';
import {Spacer} from '../../ui-toolkit/custom-feature/spacer/Spacer';

const NavigationTopbarTitle = styled(HeaderTitle)`
    margin-right: 12px;
`;

const NavigationTopbarContainer = styled.div`
    ${colorTheme({
        '--navigation-topbar-background      ': {dark: 'var(--black-14)  ', light: 'var(--white-00)'},
        '--navigation-topbar-shadow      ': {dark: 'var(--shadow-dark-02)  ', light: 'var(--shadow-light-02)'},
    })};
    grid-area: header;
    position: sticky;
    top: 0;
    z-index: var(--z-index-navigation-topbar);
    left: 0;
    width: 100%;
    min-height: var(--hamburger-btn-size);

    padding: var(--nav-topbar-padding);
    padding-left: var(--topbar-left-padding);
    background: var(--navigation-topbar-background);
    border: 0;
    box-shadow: var(--navigation-topbar-shadow);
    display: flex;
    color: var(--default-text-color);
    align-items: center;
    flex-wrap: wrap;

    ${Spacer} {
        flex-wrap: wrap;
    }
`;

function NavigationTopbar({children}) {
    return <NavigationTopbarContainer id="navigationHeaderBar">{children}</NavigationTopbarContainer>;
}

NavigationTopbar.Title = NavigationTopbarTitle;
export {NavigationTopbarTitle, NavigationTopbarContainer};
export default NavigationTopbar;
